import { AnimatePresence, motion } from 'framer-motion'

import { useEffect, useState } from 'react'
import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'
import { MainImage } from './styled'

const INTERVAL_MS = 5000
const IMAGE_SIZE_SMALL = 640
const IMAGE_SIZE_LARGE = 1400
const IMAGES = (width: number) => [
  `https://gdb.rferl.org/01000000-0aff-0242-0526-08db8e08a3db_w${width}.jpg`,
  `https://gdb.rferl.org/01000000-0aff-0242-3759-08db70b37c1a_w${width}.jpg`,
  `https://gdb.rferl.org/01000000-0aff-0242-45b8-08db70b37c2f_w${width}.jpg`,
  `https://gdb.rferl.org/01000000-0a00-0242-af4f-08db8e091d31_w${width}.jpg`,
  `https://gdb.rferl.org/01000000-0aff-0242-c3da-08db70b38382_w${width}.jpg`,
  `https://gdb.rferl.org/01000000-0aff-0242-272f-08db70b383c0_w${width}.jpg`,
  `https://gdb.rferl.org/01000000-0aff-0242-c13c-08db70b383bf_w${width}.jpg`,
  `https://gdb.rferl.org/01000000-0aff-0242-b5cf-08db70b38bfb_w${width}.jpg`,
]

export const Slideshow = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const isMobile = useMedia([breakpoints.smallOnly], [true], false)

  useEffect(() => {
    const imageSize = isMobile ? IMAGE_SIZE_SMALL : IMAGE_SIZE_LARGE

    // Preload images
    IMAGES(imageSize).forEach(image => {
      const i = new Image()
      i.src = image
    })

    // Initiate slideshow
    const interval = setInterval(() => {
      setCurrentIndex(i => (i + 1) % IMAGES(imageSize).length)
    }, INTERVAL_MS)

    // Cleanup
    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <AnimatePresence>
      <motion.picture key={currentIndex}>
        <source
          srcSet={IMAGES(IMAGE_SIZE_LARGE)[currentIndex]}
          media={breakpoints.medium}
        />
        <MainImage
          as={motion.img}
          src={IMAGES(IMAGE_SIZE_SMALL)[currentIndex]}
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
          }}
          exit={{
            opacity: 1,
          }}
        />
      </motion.picture>
    </AnimatePresence>
  )
}
